// biome-ignore lint/suspicious/noExplicitAny: We don't know the type
export const trace = import.meta.env.DEV ? (...args: any) => console.log('[src/index]', ...args) : () => {};
